import React from 'react';
import ExternalSvg from 'components/ExternalSvg';
import { AshaIconProps } from '../types';

const AshaCurriesNonVeg = ({ width = '24px', height = '24px' }: AshaIconProps) => (
  <ExternalSvg customer="asha" iconName="ashaCurriesNonVeg" width={width} height={height} />
);

export default AshaCurriesNonVeg;
